import { Component, inject } from '@angular/core';
import { AccountService } from '../../../../../../../services/account.service';
import { ButtonIconComponent } from '../../../../../../../shared/components/button-icon/button-icon.component';
import {
  InputTextChipComponent,
} from '../../../../../../../shared/components/input-text-chip/input-text-chip.component';
import { TranslateSafePipe } from '../../../../../../../shared/pipes/translation.pipe';
import { AlarmRuleActionEmailConfig } from '../../../../../../../types/dtos/alarm-rule-action.dto';
import { InputTextChipInterface } from '../../../../../../../types/interfaces/input.interface';
import { BaseAction } from '../base-action';
import { EmailRuleAction } from './email.rule-action';

@Component({
  selector: 'app-email-action',
  imports: [
    InputTextChipComponent,
    ButtonIconComponent,
    TranslateSafePipe,
  ],
  templateUrl: './email-action.html',
  styleUrls: [
    './email-action.css',
    '../base-rule-action.css',
  ],
})
export class EmailAction extends BaseAction {
  public ruleAction: EmailRuleAction = new EmailRuleAction();
  public hasEmailError: boolean = false;
  private readonly _accountService: AccountService = inject(AccountService);

  public get getDefaultValueString(): string {
    let config: AlarmRuleActionEmailConfig | undefined = this.getConfig() as AlarmRuleActionEmailConfig;
    return config?.to?.join(', ') ?? '-';
  }

  public getEmailListInput(): InputTextChipInterface {
    return {
      formGroup: this.formGroup,
      isTranslated: true,
      label: 'common.input.emails.label',
      required: true,
      id: 'emailTo',
      onInput: () => {
        this.hasEmailError = false;
      },
      isValid: (value: string) => {
        const isValid: boolean = this.ruleAction.EMAIL_REGEX.test(value.trim());
        this.hasEmailError = !isValid;
        return isValid;
      },
      predefinedValues: this._accountService.getEmailListOfUsers(),
    };
  }
}
